export default __webpack_public_path__ + "static/media/pdf.5314bcc1.png";